import { render, staticRenderFns } from "./tren_medkon_medsos.vue?vue&type=template&id=211179bb&"
import script from "./tren_medkon_medsos.vue?vue&type=script&lang=js&"
export * from "./tren_medkon_medsos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports